import { trackEvent } from '../../../modules/analytics';

export const clickNavLink = attributes => {
  trackEvent('nav_item_clicked', attributes, {
    providers: [mParticle],
  });
};
export const clickSignupButton = () => {
  trackEvent(
    'CompleteRegistration',
    {},
    {
      providers: [fbq],
    }
  );
};
